import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { AppWrapper } from 'context/AppContext';
import AllRoutes from 'routes';
import theme from 'theme/theme';
import { DrawerWrapper } from 'context/DrawerContext';
import { AuthWrapper } from 'context/AuthContext';
import './App.css';
function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppWrapper>
          <AuthWrapper>
            <DrawerWrapper>
              <AllRoutes />
            </DrawerWrapper>
          </AuthWrapper>
        </AppWrapper>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
